<div class="rounded-3xl font-medium mb-2 grid grid-cols-[auto_repeat(11,minmax(0,1fr))] gap-x-2"(keydown)="keydown()" tabindex="0">
    <div class="mt-2 pt-2 col-span-1">
        <lib-app-icon [icon]="iconType()" [size]="'20x16'" className="icon-filled"/>
    </div>
    <div class="rounded-3xl flex mt-0.5 flex-col pr-2 pt-2 pb-2 text-sm font-medium leading-[20px] tracking-[0.1px] col-span-11">
        <div class="flex items-center gap-[2px] justify-between align-middle">
            <div class="flex justify-start items-center">
                <span class="legNumberLabel grey-label" i18n>Shipment number: </span>
                <span class="value ml-1">{{legTourPoint().shipmentNumber}}</span>
                <app-chip
                    class="ml-2"
                    [content]="legTourPoint().serviceAreaIdentifier?.trim() ?? ''"
                    className="relative text-center mt-1 mb-1 mr-1 rounded-2xl overflow-hidden !flex text-xs final-branch"/>
            </div>
            @if(isEligibleForLoadingLegs()) {
                @if(staysLoaded()) {
                    <button mat-button  (click)="stayLoadedClick($event)" (keydown)="keydown()" tabindex="0" class="staysLoadedButton grey-border unloadButtonColour">
                        <div class="flex items-center px-2 py-0.5">
                            <lib-app-icon icon="check_mark_icon" [size]="'16x16'" class="mr-1"/>
                            <span i18n>Loaded</span>
                        </div>
                    </button>
                } @else {
                    <button
                        mat-button
                        (click)="stayLoadedClick($event)"
                        (keydown)="keydown()"
                        tabindex="0"
                        class="staysLoadedButton grey-border stayLoadedButtonColour"
                        [disabled]="isDisabled()">
                            <div class="flex items-center px-2 py-0.5">
                                <span class="w-max" i18n>Stay loaded</span>
                            </div>
                    </button>
                }
            }
           
        </div>
        <div class="flex flex-wrap">{{legTourPoint().name}}</div>
        <div class="value flex justify-between items-center">
            <div>
                {{legTourPoint().street}}
            </div>
            <button
                [class]="this.getIsOmsEditDisabled() ? 'opacity-50' : ''"
                [disabled]="this.getIsOmsEditDisabled()"
                (click)="this.omsLinkService.editShipmentClick(
                    this.getIsOmsEditDisabled(),
                    this.legTourPoint().shipmentId)"
            >
                <lib-app-icon
                    icon="edit_icon"
                    [size]="'16x16'"
                    tabindex="0"
                    i18n-aria-label
                    [attr.aria-label]="getTooltipText()"
                    i18n-mat-tooltip
                    [matTooltip]="getTooltipText()"
                    matTooltipPosition="below"
                    matTooltipClass="cal-tooltip"
                />
            </button>
        </div>
        <div>
            {{legTourPoint().country}}-{{legTourPoint().zipCode}} {{legTourPoint().city}}
        </div>
        <div class="flex flex-wrap">
            @for(chip of legTourPoint().infoChips; track chip.name) {
                <cal-draggable-card-info-chip [chip]="chip" className="max-w-[210px] !border !border-solid tour-point-chip"/>
            }
        </div>
    </div>
</div>